// eslint-disable-next-line no-unused-vars
import { motion } from 'framer-motion';
import Logo from '@/shared/components/modules/Logo.jsx';

// Assets
import logo from '@/assets/images/Logo.png';
import whiteLogo from '@/assets/images/WhiteLogo.png';

export default function SplashScreen() {
  const appVersion = `نسخه ${import.meta.env.VITE_APP_VERSION}`;

  return (
    <motion.div
      key="splash-screen"
      initial={{ opacity: 1 }}
      exit={{
        opacity: 0,
        scale: 1.02,
        transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
      }}
      className="fixed top-0 left-0 z-[99999] flex h-[100dvh] w-full flex-col items-center justify-between bg-slate-50 pt-[max(env(safe-area-inset-top),1rem)] pb-[max(env(safe-area-inset-bottom),1rem)] select-none dark:bg-[#111827]"
    >
      <div className="flex-1" />
      <div className="flex flex-1 items-center justify-center">
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 10 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: 'easeOut',
          }}
        >
          <Logo
            src={logo}
            darkSrc={whiteLogo}
            alt="اینتلیو"
            imageClassName="h-16 sm:h-20 w-auto object-contain drop-shadow-xl"
          />
        </motion.div>
      </div>

      <div className="mb-8 flex flex-1 items-end justify-center">
        <motion.div
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="flex flex-col items-center gap-3"
        >
          <div className="flex gap-1.5">
            {[0, 1, 2].map((index) => (
              <motion.div
                key={index}
                animate={{
                  opacity: [0.15, 1, 0.15],
                  scale: [0.8, 1, 0.8],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 1.5,
                  delay: index * 0.2,
                  ease: 'easeInOut',
                }}
                className="h-1.5 w-1.5 rounded-full bg-[var(--color-primary-100)]"
              />
            ))}
          </div>
          <p className="text-[13px] font-medium tracking-widest text-gray-400 dark:text-gray-500">
            {appVersion}
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
}
